<template>
  <div v-if="$store.getters.isLoggedIn"
       class="navbar-submenu"
       @mouseover="showSubMenu = true"
       @mouseleave="showSubMenu = false"
  >
    <span class="navbar-button">
      <i
        v-if="stompStatus === 'connected'"
        v-help.mouse="`Online`"
        class="fas fa-circle"
        style="color: GreenYellow"
      ></i>
      <i
        v-else-if="stompStatus === 'connecting'"
        v-help.mouse="`Pripojuji se k updatum serveru`"
        style="color: Gold"
        class="fas fa-sync-alt fa-spin"
      ></i>
      <i
        v-else
        v-help.mouse="`Nelze se pripojit k updatum ze serveru`"
        class="fas fa-cloud-download-alt"
        style="color: OrangeRed"
      ></i>
    </span>

    <div v-if="showSubMenu"
         class="submenu-dropdown"
    >
      <div class="dropdown-header">
        Online uživatelé
      </div>
      <div v-for="u in onlineUsersList"
           :key="u.userId"
           class="dropdown-item"
      >
        <strong>{{ u.userName }}</strong> (ping: {{ u.lastPingFormatted }})
      </div>
      <div v-if="onlineUsersList.length === 0"
           class="dropdown-item"
      >
        Nikdo další není online
      </div>

      <div class="dropdown-header">
        Aktivní zámky
      </div>
      <div v-if="activeLocks.length === 0"
           class="dropdown-item"
      >
        Žádné aktivní zámky
      </div>
      <div v-for="lock in activeLocks"
           :key="lock.entity"
           class="dropdown-item"
      >
        <strong>ID:</strong> {{ lock.entity }}<br>
        <strong>Uživatel:</strong> {{ lock.userName }}<br>
        <strong>Start:</strong> {{ lock.startTimeFormatted }}<br>
        <strong>Last Ping:</strong> {{ lock.lastPingFormatted }}<br>
        <small>Zbývá: {{ lock.ttl }}s</small>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from 'CORE/bus'
import moment from 'moment'
import _ from 'lodash'

export default {
    name: 'OnlineUpdates',
    data() {
        return {
            showSubMenu: false,
            now: Date.now(),
        }
    },
    computed: {
        stompStatus() {
            return this.$store.getters.stompStatus
        },
        activeLocks() {
            // Recompute this when `now` changes or locks change
            this.now // trigger dependency
            return _.map(this.$store.getters.getAllLocks, (lock, entity) => {
                const user = this.$store.getters.userById(lock.user)
                return {
                    entity: entity,
                    userName: user ? user.username : 'Neznámý',
                    startTimeFormatted: moment(lock.startTime).format('HH:mm:ss'),
                    lastPingFormatted: moment(lock.lastPing).format('HH:mm:ss'),
                    ttl: lock.ttl,
                }
            })
        },
        onlineUsersList() {
            this.now // trigger dependency
            return _.chain(this.$store.getters.getOnlineUsers)
                .map((lastPing, userId) => {
                    const user = this.$store.getters.userById(userId)
                    return {
                        userId,
                        userName: user ? user.username : 'Neznámý',
                        lastPingFormatted: moment(lastPing).format('HH:mm:ss'),
                    }
                })
                .filter(u => u.userId !== this.$store.getters.currentUserId) // Don't list myself
                .value()
        },
    },
    async mounted() {
        setInterval(() => {this.now = Date.now()}, 1000)
        EventBus.$on('STOMP_STATUS', status => {
            if (status === 'disconnected') {
                // eslint-disable-next-line no-new
                new Notification('ASD', { body: 'Updaty odpojeny!' })
            }
        })
    },
}
</script>

<style scoped lang="scss">
.navbar-submenu {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 28px;
    position: relative;
}

.submenu-dropdown {
    position: absolute;
    top: 30px;
    right: 0;
    width: 320px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 10000;
    color: #333;
    text-align: left;
    line-height: 1.4;
    font-size: 0.85rem;
}

.dropdown-header {
    background: #f8f9fa;
    padding: 8px 12px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    color: #555;
}

.dropdown-item {
    padding: 10px 12px;
    border-bottom: 1px solid #eee;
}

.dropdown-item:last-child {
    border-bottom: none;
}
</style>
